__turbopack_context__.v({
  "back": "g8AgrG_back",
  "container": "g8AgrG_container",
  "isVisible": "g8AgrG_isVisible",
  "link": "g8AgrG_link",
  "menu": "g8AgrG_menu",
  "showAll": "g8AgrG_showAll",
});
